module.exports = "<p>\n  forms works!\n</p>\n"